<template>
  <v-autocomplete
    v-model="filter.hierarquia"
    :items="axis"
    item-text="nome"
    item-value="usuarioGrupoId"
    placeholder="Grupos"
    @change="change"
    multiple
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
    >
      <div style="margin-right: 32px">
        <v-icon
          :color="
            filter.hierarquia && filter.hierarquia.length > 0
              ? 'indigo darken-4'
              : ''
          "
          >{{ icon }}</v-icon
        >
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <span v-if="index < maxDisplay"
        >{{ item.nome
        }}{{
          index === 0 && filter.hierarquia && filter.hierarquia.length > 1
            ? ","
            : ""
        }}
        &nbsp;</span
      >
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{
          filter.hierarquia && filter.hierarquia.length - maxDisplay
        }}
        grupos)</span
      >
    </template>

    <template slot="no-data"> Nenhum grupo retornadp </template>
  </v-autocomplete>
</template>

<script>
import { groupsAPI } from "../API/groupsAPI";

export default {
  name: "AppAxisByProjectCombobox",
  props: ["filter"],
  mounted() {
    this.loadAxis();
  },
  methods: {
    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.hierarquia = [];
        } else {
          this.filter.hierarquia = this.axis.slice();
        }
      });
    },
    loadAxis() {
      groupsAPI
        .get()
        .then((resp) => {
          this.axis = resp.data;
        })
        .catch();
    },
    change(val) {
      this.filter.hierarquia = val.map((item) => ({
        usuarioGrupoId: item,
      }));
    },
  },
  computed: {
    likesAll() {
      return (
        this.filter.hierarquia &&
        this.filter.hierarquia.length === this.axis.length
      );
    },
    likesSome() {
      return (
        this.filter.hierarquia &&
        this.filter.hierarquia.length > 0 &&
        !this.axis
      );
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
  },

  data() {
    return {
      maxDisplay: 2,
      axis: [],
    };
  },
};
</script>
